import { LitElement, html } from 'lit';

class AppFooter extends LitElement {
    // No Shadow DOM - use Light DOM for Tailwind compatibility
    createRenderRoot() {
        return this;
    }

    get copyrightYear() {
        return new Date().getFullYear();
    }

    render() {
        return html`
            <footer role="contentinfo" class="p-10 text-center text-sm">
                <div>
                    <span class="m-0"
                        >&copy; ${this.copyrightYear}
                        <a href="https://www.reach.nz/" target="_blank" rel="noreferrer">REACH</a>.
                        All Rights Reserved</span
                    >
                    &bull;
                    <a href="https://www.reach.nz/privacy-policy/" target="_blank" rel="noreferrer"
                        >Privacy&nbsp;Policy</a
                    >
                </div>
                <div class="mt-2 text-xs font-thin font-mono text-gray-300">
                    v${import.meta.env.VITE_APP_VERSION || 'dev'}
                </div>
            </footer>
        `;
    }
}

customElements.define('app-footer', AppFooter);
